import { Typography } from '@paintscout/ui'
import React from 'react'

export default function WisetackDepositExplanation() {
  return (
    <Typography variant="body2">
      If the calculated deposit amount <strong>exceeds $500</strong> <i>and</i> is{' '}
      <strong>less than half of the total</strong>, financing will be split into two payouts.
    </Typography>
  )
}
